module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"fi":{"downloadStatistics":{"title":"Lataa tilasto"},"teams":{"title":"Piirin joukkueet","noItemsText":"Piirillä ei ole joukkueita"},"standings":{"title":"Sarjataulukko"}}}')
  delete Component.options._Ctor
}
